export const ORIENTATIONS = "/api/folders/:param/orientations"
export const ORIENTATION = "/api/orientations/:orientationParam"
export const CLOSE_ORIENTATION = "/api/orientations/:orientationParam/validation"
export const EXPORT_ORIENTATION = "/api/orientations/export"
export const GENERATE_ORIENTATION = "/api/orientations/link_document/:param/generate"
export const UNCLOSE_ORIENTATION = "/api/orientations/:orientationParam/disprove"
export const GENERATE_GLOBAL_RESULT = "/api/orientations/:param/integration-report/generate/:lang"
